import React from 'react'

import imgBackground from "../../images/header_background.png"
import imgLogo from "../../images/logo.png"

const Header = (props) => {

    return (
        <>
            <div
                className="header-banner"
                style={{
                    backgroundImage: `url(${imgBackground})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    width: '100%',
                    minHeight: 'auto',
                    position: 'relative'
                }}
            >
                <div className="container pt-0 wrapper-smaller">

                    <div className="row pt-4 pb-4">
                        <div className="col-md-12">
                            <a href="https://www.swissfintechweek.com/">
                                <img style={{maxWidth: "200px"} } className="img-fluid" src={imgLogo} alt="" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Header